import IPicture from './IPicture';

export default class UploadedPicture implements IPicture {
  constructor(private url: string) {}

  public getUrl(): string {
    return this.url;
  }

  public async getImageForPreview(): Promise<string> {
    return this.url;
  }
}
